import template from './print_routes.html';
import controller from './print_routes.controller';
import './print_routes.scss';

let printRoutesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printRoutesComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/routes/print/print_routes.component.js